<script setup>
const { ages, format, skillLevels, duration } = useCourseData();

const props = defineProps({
  data: Object,
  price: String,
  title: String,
  variants: Object
})
const modalId = "course-social-share-modal";
const durationBasedOnDivision = (pulseCourse) => {
  if (pulseCourse.division.id === 41) {

    let variantProducts = props.variants
      .filter(product => product !== null && product.visibilityTypeId !== 330003 && product.visibilityTypeId !== 330004)
      .map(variantProduct => variantProduct.quantity);

    if (variantProducts.length) {
      variantProducts.sort((a, b) => a - b);
      variantProducts = variantProducts.join(', ');
    } else {
      variantProducts = pulseCourse.quantity;
    }
    return variantProducts + " " + duration(pulseCourse);
  } else {
    return duration(pulseCourse);
  }
};

</script>

<template>
  <div class="block course-details">
    <UIHeading :titleComponent="{title: props.title, heading: 'h1'}" :titleClass="'title px-2'"/>
    <button id="course-social-share-modal-button" class="font-weight-bold btn btn-link px-4 my-2" data-bs-toggle="modal" data-bs-target="#course-social-share-modal">
      <UIIconsShare />
      <span>Share</span>
    </button>
    <div class="vertical-gradient vertical-gradient--inner ps-5">
      <ul class="list-unstyled">
        <li class="pb-1"><strong>Price:</strong> {{ price }}</li>
        <li class="pb-1"><strong>Age:</strong> {{ ages(data) }}</li>
        <li class="pb-1"><strong>Skill Level:</strong> {{ skillLevels(data) }}</li>
        <li class="pb-1"><strong>Format:</strong> {{ format(data) }}</li>
        <li class="pb-1"><strong>Duration:</strong> {{ durationBasedOnDivision(data) }}</li>
      </ul>
    </div>
    <UISocialShareModal :title="props.title" :division="data.division.name" :modalId="modalId" />
  </div>
</template>

<style lang="scss">
.course-details {
  color: $color-primary;

  h1 {
    font-size: 2rem;
  }

  #course-social-share-modal-button {
    color: inherit;
    background-color: transparent;
    border: none;
    border-radius: 0;
    text-align: left;
    text-decoration: none;
    font-size: $font-size-base;

    &:hover {
      color: $link-primary-color;
      text-decoration: underline;
    }
  }
}

</style>
